// BL-177 Step 2h: plain-English line for "what did this device do with the last push" (Settings > My notifications > This device).
// `report` is push_tokens.last_report, written by the push-delivery-report Edge Function from the push worker's report-back.
const BROWSERS = { chrome: 'Chrome', edge: 'Edge', safari: 'Safari', firefox: 'Firefox', opera: 'Opera', other: 'this browser' };

export function describeDeviceReport(report) {
    if (!report || typeof report !== 'object') return '';
    if (report.result === 'shown') {
        const quiet = report.silent ? ' without sound' : '';
        if (report.fallback) return `Shown as a plain banner${quiet}: the full one was rejected${report.message ? ` (${report.message})` : ''}`;
        return `Banner shown${quiet}${report.confirmed === false ? ', but the browser did not list it' : ''}`;
    }
    if (report.result === 'suppressed-visible') return 'No banner: this app was open and in front, so it showed the in-app pop-up instead';
    if (report.result === 'suppressed-silent') return 'No banner: alerts are set to silent for this device';
    if (report.result === 'error') {
        const reason = report.permission && report.permission !== 'granted' ? `notification permission is "${report.permission}"` : report.message;
        return `The banner could not be shown${reason ? `: ${reason}` : ''}`;
    }
    return '';
}

export function describeReportMeta(report, now = Date.now()) {
    if (!report || !report.reportedAt) return '';
    const at = new Date(report.reportedAt);
    if (Number.isNaN(at.getTime())) return '';
    const minutes = Math.round((now - at.getTime()) / 60000);
    const when = minutes < 1 ? 'just now' : minutes < 60 ? `${minutes} min ago` : at.toLocaleString([], { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
    const browser = BROWSERS[report.browser] || BROWSERS.other;
    return `${report.test ? 'Test push' : 'Last alert'} · ${when} · ${browser}${report.workerVersion ? ` · worker ${report.workerVersion}` : ''}`;
}
